import React, { Component } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from "@material-ui/core/Switch"
import { withTranslation } from 'react-i18next';

class WrappedFromControlLabel extends Component {

    render() {
        return (
            <FormControlLabel
                control={
                    <Switch
                        onChange={(e) => this.props.onChange(e)}
                        checked={this.props.checked}
                        name={this.props.name}
                        color="primary"
                    />
                }
                label={this.props.t(this.props.label)}
            />
        );
    }
}

export default withTranslation()(WrappedFromControlLabel);
